export default __webpack_public_path__ + "static/media/home_web-xs@2x.09d70cad.jpg";